import { render, staticRenderFns } from "./FeeDetail.vue?vue&type=template&id=2ec474fd&scoped=true&"
import script from "./FeeDetail.vue?vue&type=script&lang=js&"
export * from "./FeeDetail.vue?vue&type=script&lang=js&"
import style0 from "./FeeDetail.vue?vue&type=style&index=0&id=2ec474fd&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec474fd",
  null
  
)

export default component.exports